import HighSchoolLessonStatusIcon from './component'

export default HighSchoolLessonStatusIcon
